/* lk-banners.js — Eyewear Essentials homepage motion sections (2026-09-12)
   Hero film slider, "Shop for" spotlight, 360 turntable, reels modal.
   No libraries. Every autoplay respects prefers-reduced-motion and stops on touch. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;

  /* ---------- hero film slider ---------- */
  function hero(root) {
    if (root.dataset.bound === '1') return; root.dataset.bound = '1';
    var track = root.querySelector('[data-lk-hm-track]');
    var slides = [].slice.call(root.querySelectorAll('[data-lk-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-lk-hm-dot]'));
    var n = slides.length, i = 0, timer = null;
    var wait = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    /* pick the lighter video file on phones */
    root.querySelectorAll('[data-lk-hm-video]').forEach(function (v) {
      /* a film slide with a phone still drops its video on phones (no download; the slide then advances like a photo) */
      if (window.innerWidth < 900 && v.closest('.has-still')) { v.parentNode.removeChild(v); return; }
      var src = window.innerWidth < 900 ? (v.dataset.srcSm || v.dataset.srcLg) : (v.dataset.srcLg || v.dataset.srcSm);
      if (src && !v.querySelector('source')) { var s = document.createElement('source'); s.src = src; s.type = 'video/mp4'; v.appendChild(s); }
    });
    function videoOf(k) { return slides[k] && slides[k].querySelector('video'); }
    function playActive() {
      slides.forEach(function (s, k) { var v = s.querySelector('video'); if (!v) return; if (k === i && !reduced) { if (v.ended) v.currentTime = 0; v.play().catch(function () {}); } else { v.pause(); } });
    }
    var userStopped = false;
    function go(k, user) {
      i = ((k % n) + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced || user === 'jump' ? 'auto' : 'smooth' });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      playActive();
      if (!userStopped) play();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    /* a film slide holds until its video ends; image slides advance on the interval */
    function play() { stop(); if (userStopped || n < 2 || reduced || root.dataset.autoplay !== 'true') return; if (videoOf(i)) return; timer = setInterval(function () { go(i + 1); }, wait); }
    function userStop() { userStopped = true; stop(); }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { userStop(); go(j); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var k = Math.round(track.scrollLeft / (slides[0].offsetWidth || 1)); if (k !== i && k >= 0 && k < n) { i = k; dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); playActive(); } }, 80);
    }, { passive: true });
    root.addEventListener('pointerdown', userStop);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); slides.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); }); } else { play(); playActive(); } });
    if (IO) { new IntersectionObserver(function (en) { if (en[0].isIntersecting) { playActive(); play(); } else { stop(); slides.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); }); } }, { threshold: .25 }).observe(root); }
    /* a video slide waits for the film to loop once before moving on */
    slides.forEach(function (s, k) {
      var vv = s.querySelector('video'); if (!vv) return;
      if (n > 1 && root.dataset.autoplay === 'true' && !reduced) { vv.loop = false; vv.addEventListener('ended', function () { if (i === k && !userStopped) go(i + 1); }); }
    });
    playActive(); play();
  }

  /* ---------- spotlight ---------- */
  function spotlight(root) {
    if (root.dataset.bound === '1') return; root.dataset.bound = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-lk-sp-slide]'));
    var n = slides.length; if (!n) return;
    var word = root.querySelector('[data-lk-sp-word]'), sub = root.querySelector('[data-lk-sp-sub]'), cta = root.querySelector('[data-lk-sp-cta]');
    var dots = [].slice.call(root.querySelectorAll('[data-lk-sp-dot]'));
    var i = 0, timer = null, wait = parseInt(root.dataset.interval, 10) || 4500;
    function draw() {
      slides.forEach(function (s, k) {
        s.classList.remove('is-active', 'is-prev', 'is-next');
        if (k === i) s.classList.add('is-active');
        else if (k === (i - 1 + n) % n) s.classList.add('is-prev');
        else if (k === (i + 1) % n) s.classList.add('is-next');
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      var s = slides[i];
      if (word) { word.classList.add('is-fading'); setTimeout(function () { word.textContent = s.dataset.word || ''; word.classList.remove('is-fading'); }, reduced ? 0 : 220); }
      if (sub) sub.textContent = s.dataset.sub || '';
      if (cta) { cta.href = s.dataset.href || cta.href; cta.textContent = s.dataset.cta || cta.textContent; }
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function go(k) { i = ((k % n) + n) % n; draw(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { stop(); if (n > 1 && !reduced) timer = setInterval(function () { go(i + 1); }, wait); }
    root.querySelectorAll('[data-lk-sp-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); stop(); }); });
    root.querySelectorAll('[data-lk-sp-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); stop(); }); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); stop(); }); });
    slides.forEach(function (s, k) { s.addEventListener('click', function () { if (k !== i) { go(k); stop(); } }); });
    var stage = root.querySelector('[data-lk-sp-stage]'), x0 = null;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; stop(); });
      stage.addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); });
      stage.addEventListener('pointercancel', function () { x0 = null; });
    }
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    if (IO) { new IntersectionObserver(function (en) { en[0].isIntersecting ? play() : stop(); }, { threshold: .3 }).observe(root); } else play();
    draw();
  }

  /* ---------- 360 turntable ---------- */
  function turntable(root) {
    if (root.dataset.bound === '1') return; root.dataset.bound = '1';
    var stage = root.querySelector('[data-lk-360-stage]');
    var sets = [].slice.call(root.querySelectorAll('[data-lk-360-set]'));
    var range = root.querySelector('[data-lk-360-range]');
    var counter = root.querySelector('[data-lk-360-n]'), total = root.querySelector('[data-lk-360-total]');
    var name = root.querySelector('[data-lk-360-name]'), price = root.querySelector('[data-lk-360-price]'), link = root.querySelector('[data-lk-360-link]');
    if (!stage || !sets.length) return;
    var setIdx = 0, frames = [], n = 0, i = 0, spin = null, dragging = false, startX = 0, startI = 0, spun = false;
    function useSet(k) {
      setIdx = k;
      sets.forEach(function (s, j) { s.hidden = j !== k; });
      frames = [].slice.call(sets[k].querySelectorAll('.lk-360-f'));
      n = frames.length; i = 0;
      if (range) { range.max = Math.max(0, n - 1); range.value = 0; }
      if (total) total.textContent = n;
      var s = sets[k];
      if (name) name.textContent = s.dataset.title || '';
      if (price) price.innerHTML = s.dataset.priceHtml || '';
      if (link) link.href = s.dataset.href || '#';
      root.querySelectorAll('[data-lk-360-col]').forEach(function (b, j) { b.classList.toggle('on', j === k); b.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      draw(0);
    }
    function draw(next) {
      if (!n) return;
      i = ((next % n) + n) % n;
      frames.forEach(function (f, k) { f.classList.toggle('on', k === i); });
      if (range) range.value = i;
      if (counter) counter.textContent = i + 1;
    }
    function stopSpin() { if (spin) { clearInterval(spin); spin = null; } root.classList.add('is-touched'); }
    function autoSpin() {
      if (reduced || spun || n < 2) return; spun = true;
      var steps = 0;
      spin = setInterval(function () { draw(i + 1); if (++steps >= n * 2) stopSpin(); }, 340);
    }
    root.querySelectorAll('[data-lk-360-col]').forEach(function (b, j) { b.addEventListener('click', function () { stopSpin(); useSet(j); }); });
    if (range) range.addEventListener('input', function () { stopSpin(); draw(parseInt(range.value, 10)); });
    stage.addEventListener('pointerdown', function (e) { dragging = true; startX = e.clientX; startI = i; stopSpin(); stage.classList.add('is-grabbing'); try { stage.setPointerCapture(e.pointerId); } catch (err) {} });
    stage.addEventListener('pointermove', function (e) { if (!dragging) return; var span = stage.getBoundingClientRect().width || 1; draw(startI + Math.round(((e.clientX - startX) / span) * n * 1.6)); });
    function end(e) { if (!dragging) return; dragging = false; stage.classList.remove('is-grabbing'); try { stage.releasePointerCapture(e.pointerId); } catch (err) {} }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    root.addEventListener('keydown', function (e) { if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return; e.preventDefault(); stopSpin(); draw(i + (e.key === 'ArrowRight' ? 1 : -1)); });
    useSet(0);
    if (IO) { new IntersectionObserver(function (en) { if (en[0].isIntersecting) autoSpin(); }, { threshold: .5 }).observe(root); }
  }

  /* ---------- reels ---------- */
  function reels(root) {
    if (root.dataset.bound === '1') return; root.dataset.bound = '1';
    var cards = [].slice.call(root.querySelectorAll('[data-lk-reel]'));
    var modal = root.querySelector('[data-lk-reel-modal]');
    var mv = modal && modal.querySelector('video'), mtitle = modal && modal.querySelector('[data-lk-reel-title]'), mlink = modal && modal.querySelector('[data-lk-reel-link]'), mute = modal && modal.querySelector('[data-lk-reel-mute]');
    /* muted preview plays only while the card is on screen */
    if (IO) {
      var io = new IntersectionObserver(function (ens) { ens.forEach(function (en) { var v = en.target.querySelector('video'); if (!v) return; if (en.isIntersecting && !reduced) { if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.src); v.play().catch(function () {}); } else { v.pause(); } }); }, { threshold: .6 });
      cards.forEach(function (c) { io.observe(c); });
    }
    var last = null;
    function open(card) {
      if (!modal || !mv) return;
      last = document.activeElement;
      mv.src = card.dataset.src; mv.muted = false; mv.currentTime = 0;
      if (mtitle) mtitle.textContent = card.dataset.title || '';
      if (mlink) { if (card.dataset.href) { mlink.href = card.dataset.href; mlink.hidden = false; mlink.textContent = card.dataset.cta || 'Shop this frame'; } else mlink.hidden = true; }
      modal.hidden = false; document.body.style.overflow = 'hidden';
      mv.play().catch(function () { mv.muted = true; mv.play().catch(function () {}); });
      if (mute) mute.textContent = mv.muted ? 'Unmute' : 'Mute';
      modal.querySelector('[data-lk-reel-close]').focus();
    }
    function close() { if (!modal) return; mv.pause(); mv.removeAttribute('src'); mv.load(); modal.hidden = true; document.body.style.overflow = ''; if (last && last.focus) last.focus(); }
    cards.forEach(function (c) { c.addEventListener('click', function () { open(c); }); });
    if (modal) {
      modal.querySelectorAll('[data-lk-reel-close]').forEach(function (b) { b.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
      if (mute) mute.addEventListener('click', function () { mv.muted = !mv.muted; mute.textContent = mv.muted ? 'Unmute' : 'Mute'; });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lk-hm]').forEach(hero);
    document.querySelectorAll('[data-lk-sp]').forEach(spotlight);
    document.querySelectorAll('[data-lk-360]').forEach(turntable);
    document.querySelectorAll('[data-lk-reels]').forEach(reels);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
